import { Fragment } from 'react';
import { Button, Divider, Drawer, IconButton, Stack } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Link } from 'react-router';
import { dictionary } from '../../dictionary';
import { palette } from '../../theme';
import type { MobileDrawerProps } from './MobileDrawer.types';
import { contactActions } from '../shared/contactActions';
import { mobileNavItems } from '../shared/navItems';

export default function MobileDrawer({ open, onClose }: MobileDrawerProps) {
  return (
    <Drawer
      anchor='right'
      open={open}
      onClose={onClose}
      SlideProps={{ direction: 'left' }}
      PaperProps={{
        sx: {
          width: '260px',
          backgroundColor: palette.primary,
          p: 2,
        },
      }}
    >
      <Stack gap={1} height={'100%'}>
        <Stack direction='row' justifyContent='flex-end'>
          <IconButton onClick={onClose} aria-label={dictionary.general.aria.closeMenu}>
            <CloseIcon sx={{ color: palette.backgroundPrimary }} />
          </IconButton>
        </Stack>

        <Stack mb={'auto'}>
          {mobileNavItems.map((item, index) => (
            <Fragment key={item.path}>
              <Button
                component={Link}
                to={item.path}
                onClick={onClose}
                sx={{
                  color: palette.backgroundPrimary,
                  justifyContent: 'flex-start',
                  fontSize: '24px',
                  fontWeight: 300,
                  '&:hover': {
                    color: palette.secondary,
                    backgroundColor: palette.backgroundSections,
                  },
                }}
              >
                {item.label}
              </Button>
              {index < mobileNavItems.length - 1 && (
                <Divider
                  sx={{ borderColor: palette.accent, width: '40px', alignSelf: 'start', marginInlineStart: '8px' }}
                />
              )}
            </Fragment>
          ))}
        </Stack>

        <Stack gap={0.5}>
          {contactActions.map((action) => (
            <Button
              key={action.label}
              component='a'
              href={action.href}
              startIcon={action.icon}
              {...(action.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
              sx={{
                gap: '16px',
                color: palette.backgroundPrimary,
                justifyContent: 'flex-start',
                fontSize: '16px',
                fontWeight: 300,
                '&:hover': {
                  color: palette.secondary,
                  backgroundColor: palette.backgroundSections,
                },
              }}
            >
              {action.label}
            </Button>
          ))}
        </Stack>
      </Stack>
    </Drawer>
  );
}
